"use client"
import styled from "@emotion/styled"
import { Container, NewText } from "ui"
import { extractProperty, replaceMediaLinksInRichText, replaceRichTextLinks } from "utils"

const StyledContainer = styled(Container)`
  border-top: 1px solid #6f6f6f;
  margin: 0 16px;
  width: calc(100% - 32px);
  padding: 0;
  padding-top: 24px;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin: auto;
    padding-bottom: 60px;
  }
`

const LegalDisclaimer = ({ pageData }: { pageData: any }) => {
  const legalDisclaimer = extractProperty(pageData, "legalDisclaimer")
  if (!legalDisclaimer) {
    return null
  }

  return (
    <StyledContainer>
      <NewText
        component={"div"}
        desktopFontSize={16}
        desktopFontWeight={400}
        desktopLineHeight={1}
        mobileFontSize={14}
        mobileFontWeight={400}
        mobileLineHeight={1}
        color="#6F6F6F"
        dangerouslySetInnerHTML={{
          __html: replaceMediaLinksInRichText(replaceRichTextLinks(legalDisclaimer)),
        }}
        maxWidth={"800px"}
      />
    </StyledContainer>
  )
}
export default LegalDisclaimer
